import React from 'react';
import { Dropdown, Input } from 'semantic-ui-react';
import styled from 'styled-components';

import {
  HALF_HOUR_OPTIONS,
  istTodayInputDate,
  joinIstLocalInput,
  splitIstLocalInput,
} from './constants';

const Fields = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  > :first-child {
    flex: 1 1 auto;
  }
`;

// Eval supply sits on :00/:30, so the time is a closed list rather than free text.
const HalfHourPicker = ({ value, onChange, ariaLabel }) => {
  // Held separately: a combined value only exists once both halves are set.
  const [parts, setParts] = React.useState(() => splitIstLocalInput(value));

  React.useEffect(() => {
    if (!value) return;
    setParts(splitIstLocalInput(value));
  }, [value]);

  const update = next => {
    setParts(next);
    onChange(joinIstLocalInput(next.date, next.time));
  };

  return (
    <Fields>
      <Input
        type="date"
        min={istTodayInputDate()}
        value={parts.date}
        onChange={(_, { value: date }) => update({ ...parts, date })}
        aria-label={`${ariaLabel} date`}
      />
      <Dropdown
        compact
        selection
        selectOnBlur={false}
        options={HALF_HOUR_OPTIONS}
        value={parts.time}
        placeholder="--:--"
        onChange={(_, { value: time }) => update({ ...parts, time })}
        aria-label={`${ariaLabel} time`}
      />
    </Fields>
  );
};

export default HalfHourPicker;
